"use client";
import { LANGUAGE_CODES } from "@/i18n/config";
import { BreadCrumb } from "@repo/ui";
import { usePathname } from "next/navigation";
import { useTranslations } from "use-intl";

const ClientBreadCrumb = () => {
  const pathname = usePathname();
  const t = useTranslations("Common");
  // Parse pathname into breadcrumb segments, skipping the language code if present
  const pathSegments = pathname
    .split("/")
    .filter((segment) => segment && !LANGUAGE_CODES.includes(segment));

  // Generate breadcrumb items, starting with home link

  const breadcrumbs = [
    { label: t("Home"), url: "/" },
    ...pathSegments.map((segment, index) => {
      const url = "/" + pathSegments.slice(0, index + 1).join("/");

      // Check if the segment is a number and avoid translation
      const isNumber = /^\d+$/.test(segment);
      const translatedLabel = isNumber
        ? segment
        : t(segment.charAt(0).toUpperCase() + segment.slice(1));

      return { label: translatedLabel, url };
    }),
  ];

  return <BreadCrumb items={breadcrumbs} />;
};

export default ClientBreadCrumb;
